<template>
  <div>
    <vl-map
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
      data-projection="EPSG:4326"
      style="height: 650px"
      @click="setPos"
    >
      <vl-view
        :zoom.sync="zoom"
        :center.sync="center"
        :rotation.sync="rotation"
        :min-zoom="3"
        :extent="[60, 90, -85, 0]"
      ></vl-view>
      <vl-geoloc @update:position="onGeolocPosition"> </vl-geoloc>
      <vl-feature id="my-locatoin" v-if="!!geolocPosition">
        <vl-geom-point :coordinates="geolocPosition"></vl-geom-point>
        <vl-style-box>
          <vl-style-icon
            src="@/assets/map-marker-icon.png"
            :scale="0.04"
            :anchor="[0.5, 1]"
          ></vl-style-icon>
        </vl-style-box>
      </vl-feature>
      <vl-layer-tile id="osm">
        <vl-source-osm></vl-source-osm>
      </vl-layer-tile>
    </vl-map>
  </div>
</template>

<script>
import mapTypes from "@/store/types/map";
export default {
  props: {
    // Ubicación que viene del componente padre (GPS propio o IP).
    // Antes no existían estas props: el componente ignoraba por completo
    // lo que el padre le pasaba y siempre arrancaba en [0, 0].
    latitude: {
      type: Number,
      default: null,
    },
    longitude: {
      type: Number,
      default: null,
    },
  },
  data() {
    const hasInitialPosition = this.latitude != null && this.longitude != null;
    // OpenLayers usa orden [longitud, latitud] con data-projection="EPSG:4326"
    const initialCoords = hasInitialPosition
      ? [this.longitude, this.latitude]
      : [0, 0];
    return {
      zoom: hasInitialPosition ? 17 : 3,
      center: initialCoords,
      rotation: 0,
      geolocPosition: hasInitialPosition ? initialCoords : undefined,
      // Evita que una actualización posterior de las props (poco probable,
      // pero posible) pise una ubicación que el usuario ya ajustó a mano
      // haciendo click en el mapa o vía la geolocalización propia de vl-geoloc.
      manualSelection: false,
    };
  },
  methods: {
    setPos(newPos) {
      this.manualSelection = true;
      this.geolocPosition = newPos.coordinate;
      this.updateVuex(this.geolocPosition);
    },
    onGeolocPosition(position) {
      this.manualSelection = true;
      this.geolocPosition = position;
    },
    updateVuex(geolocPosition) {
      this.$store.commit(mapTypes.mutations.setLongitude, geolocPosition[0]);
      this.$store.commit(mapTypes.mutations.setLatitude, geolocPosition[1]);
      this.center = [geolocPosition[0], geolocPosition[1]];
      this.zoom = 17;
    },
    /**
     * Sincroniza centro, zoom y marcador cuando el PADRE actualiza
     * latitude/longitude (por ejemplo, cuando obtenerUbicacionSilenciosa()
     * resuelve la ubicación por IP después de que el mapa ya se montó).
     */
    syncFromProps() {
      if (this.manualSelection) {
        return;
      }
      if (this.latitude == null || this.longitude == null) {
        return;
      }
      const coords = [this.longitude, this.latitude];
      this.center = coords;
      this.geolocPosition = coords;
      this.zoom = 17;
    },
  },
  watch: {
    geolocPosition() {
      if (!!this.geolocPosition) {
        this.updateVuex(this.geolocPosition);
      }
    },
    latitude() {
      this.syncFromProps();
    },
    longitude() {
      this.syncFromProps();
    },
  },
};
</script>
